import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { RocheUIButton as p } from "../button/roche-button.js";
import { RocheUIButtonAppearance as m, RocheUIButtonType as h } from "../button/roche-button-types.js";
import a from "./roche-teaser-wall.module.scss.js";
const I = ({
  items: c,
  canLoadMore: o,
  isLoadingMore: t = !1,
  loadMoreLabel: s,
  onLoadMore: l,
  slot: n
}) => /* @__PURE__ */ i("div", { className: a["teaser-wall"], slot: n, children: [
  /* @__PURE__ */ e("ul", { className: a["teaser-wall__teasers"], role: "list", children: c.map((r) => /* @__PURE__ */ e("li", { className: a["teaser-wall__teaser"], children: r.content }, r.key)) }),
  (o || t) && l && s && /* @__PURE__ */ e("div", { className: a["teaser-wall__button"], children: /* @__PURE__ */ e(
    p,
    {
      text: s,
      type: h.BUTTON,
      appearance: m.PRIMARY,
      hasMarginTop: !1,
      isLoading: t,
      onClick: l
    }
  ) })
] });
export {
  I as RocheUITeaserWall
};
